import React from 'react';

import { AppButton, StyledText, StyledDiv } from './StyledComponents';

const SPButton = props => {
  const {
    title,
    htmlType,
    onButtonClick,
    isLoading,
    size,
    image,
    type,
    disabled,
    rightImage,
    icon,
    style,
    height,
  } = props;

  let defaultHeight = 42;

  switch (size) {
    case 'small':
      defaultHeight = 33;
      break;
    case 'medium':
      defaultHeight = 42;
      break;
    case 'large':
      defaultHeight = 55;
      break;

    default:
      defaultHeight = 42;
      break;
  }
  return (
    <AppButton
      style={style}
      type={type}
      htmlType={htmlType}
      onClick={onButtonClick}
      loading={isLoading}
      block
      height={height || defaultHeight}
      disabled={disabled}
    >
      {image}
      <StyledText> {title} {icon}</StyledText>
      {rightImage ? <StyledDiv>{rightImage}</StyledDiv> : null}
    </AppButton>
  );
};

export default SPButton;
